"use client";

import { useRouter } from "next/navigation";

import { Button } from "@/components/ui/button";
import endpoints from "@/constants/endpoints";

//

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50">
      <div className="mx-auto flex max-w-md flex-col justify-center text-center">
        <h1 className="mb-2 text-6xl font-extrabold text-blue-500">404</h1>
        <h2 className="mb-4 text-2xl font-semibold text-gray-900">Страница не найдена</h2>
        <p className="mb-8 text-gray-600">
          Извините, страница, которую вы ищете, не существует или была перемещена. Проверьте
          правильность URL или воспользуйтесь ссылкой ниже.
        </p>
        <div className="mx-auto flex gap-3">
          <Button icon={"ArrowLeft"} variant={"outline"} onClick={() => router.back()}>
            Назад
          </Button>
          <Button
            icon={"House"}
            variant={"outline"}
            onClick={() => router.replace(endpoints.findPath("dashboard"))}
          >
            На главную
          </Button>
        </div>
      </div>
    </div>
  );
}
